__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/c61b77a/_next/";